export default __webpack_public_path__ + "static/alerts-83b2d03e1406b2766dbc83a9d168f23b.png";